// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebars_sidebar__I-A2k","sidebar_mobile_wrapper":"Sidebars_sidebar_mobile_wrapper__wckP8","open-sidebar":"Sidebars_open-sidebar__BF5Gl"};